import React from 'react';
import { withTranslation, useTranslation } from 'react-i18next';

function PaginateTotal(props) {
    const { t } = useTranslation();
    const { pageNo, pageSize, total } = props;

    const start = Math.min(pageNo * pageSize + 1,total);
    const end = Math.min((pageNo + 1) * pageSize,total);

    return (
        <div className="pagination-toolbar total">
            {t('common:pagination.total',{ start:start, end:end, total:total })}
        </div>
    );
}

export default withTranslation()(PaginateTotal);